import React from "react";
import WarningSnackbar from "components/shared/snackbars/WarningSnackbar";

interface WarningMessageProps {
	show: boolean;
	onClickClose: () => void;
	text: string;
}

class WarningMessage extends React.Component<WarningMessageProps> {
	state = {
		open: false,
		text: ""
	};

	shownPropChanged = prevProps => prevProps.show !== this.props.show;

	successMessageShouldBeShown = prevProps => this.shownPropChanged(prevProps) && this.props.show;

	successMessageShouldBeHidden = prevProps =>
		this.shownPropChanged(prevProps) && !this.props.show;

	textChanged = prevProps => prevProps.text !== this.props.text;

	componentDidMount() {
		if (this.props.show) {
			this.setState({ open: true, text: this.props.text });
		}
	}

	componentDidUpdate(prevProps) {
		if (this.successMessageShouldBeShown(prevProps)) {
			this.setState({
				open: true,
				text: this.props.text
			});
		}

		if (this.successMessageShouldBeHidden(prevProps)) {
			this.setState({
				open: false
			});
		}

		if (this.textChanged(prevProps) && !this.successMessageShouldBeHidden(prevProps)) {
			this.setState({
				text: this.props.text
			});
		}
	}

	render() {
		return (
			<WarningSnackbar
				onClickClose={this.props.onClickClose}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
				open={this.state.open}
				message={this.state.text}
			/>
		);
	}
}

export default WarningMessage;
